import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";

const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

export const DropZone = ({
  onFiles, accept, multiple = false, busy = false, icon: Icon = Upload,
  titel, hinweis, aktion = "Datei auswählen", testid, variant = "primary",
}) => {
  const ref = useRef(null);
  const [over, setOver] = useState(false);

  const nimm = (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    onFiles(multiple ? files : [files[0]]);
  };

  const basis = variant === "primary"
    ? "bg-[#BA6D52] text-white hover:bg-[#A55C43]"
    : "border border-[#BA6D52] text-[#BA6D52] hover:bg-[#FAF5F1]";

  return (
    <div
      data-testid={testid}
      data-file-drop="1"
      onDragEnter={(e) => { stop(e); setOver(true); }}
      onDragOver={(e) => { stop(e); setOver(true); }}
      onDragLeave={(e) => { stop(e); setOver(false); }}
      onDrop={(e) => { stop(e); setOver(false); if (!busy) nimm(e.dataTransfer?.files); }}
      onClick={() => !busy && ref.current?.click()}
      className={`border border-dashed p-5 text-center transition-colors ${busy ? "cursor-wait opacity-70" : "cursor-pointer"} ${
        over ? "border-[#BA6D52] bg-[#F2EFE9] ring-2 ring-[#BA6D52]/30" : "border-[#E3DECE] bg-white hover:border-[#BA6D52]"
      }`}
    >
      {titel && <p className="text-[10px] uppercase tracking-[0.2em] text-[#BA6D52] mb-2">{titel}</p>}
      <div className="flex justify-center mb-3">
        {busy ? <Loader2 size={22} className="animate-spin text-[#BA6D52]" />
          : <Icon size={22} className={over ? "text-[#BA6D52]" : "text-[#A8A29A]"} />}
      </div>
      <p className="text-sm text-[#2C2A26] mb-1">
        {over ? "Jetzt loslassen" : multiple ? "Dateien hierher ziehen" : "Datei hierher ziehen"}
      </p>
      {hinweis && <p className="text-xs text-[#757067] mb-4">{hinweis}</p>}
      <input ref={ref} type="file" accept={accept} multiple={multiple} className="hidden"
        data-testid={testid ? `${testid}-input` : undefined}
        onChange={(e) => { nimm(e.target.files); e.target.value = ""; }} />
      <span
        data-testid={testid ? `${testid}-button` : undefined}
        className={`${basis} px-5 py-2.5 text-xs uppercase tracking-[0.2em] inline-flex items-center justify-center gap-2`}
      >
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Icon size={14} />}
        {busy ? "Wird verarbeitet …" : aktion}
      </span>
    </div>
  );
};

export default DropZone;
